import type {
  ApiPostDealFinanceV1ProfitabilityCalculatorCreate400,
  ApiTransportPricesV1EstimateCreate400,
  ErrorResponse,
  ErrorType,
  OutputPropertyValue,
  QualityOutputMetricEnum,
} from 'api';

export type NetTakeError = ErrorType<ApiPostDealFinanceV1ProfitabilityCalculatorCreate400 | ErrorResponse> | null;
export type TransportPriceEstimateError = ErrorType<ApiTransportPricesV1EstimateCreate400 | ErrorResponse> | null;

export type NetTakeRate = {
  rate?: number;
  error?: NetTakeError;
  isLoading?: boolean;
};

export type Recipient = {
  id: number;
  email: string;
  phone_number?: string;
};

export const QualityDataInput = {
  AI_BALE_SURFACE: 'AI Bale Surface',
  AI_BRIQUETTE_SURFACE: 'AI Briquette Surface',
  AI_GRAVI: 'AI Gravi',
  MANUAL_SAMPLE: 'Manual Sample',
  WEIGHT_CONTENT: 'Weight Content',
};

export type QualityData = {
  quality_output_metric: QualityOutputMetricEnum;
  properties: { [key: string]: OutputPropertyValue };
};
